import { Dispatch, FunctionComponent, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";
import { Checkbox } from "@/components/Checkbox/Checkbox";

import { BlacklistCsvUploadFields } from "../../Blacklist/components/BlacklistCsvUploadFields";
import { useUploadBlacklistCsv } from "../../Blacklist/components/useUploadBlacklistCsv";

interface UploadBlacklistModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	isGlobal: boolean;
	/** Staff only: global entries block for every workspace (PREC-4347). */
	canImportGlobal: boolean;
}

export const UploadBlacklistModal: FunctionComponent<UploadBlacklistModalProps> = ({
	isOpen,
	setIsOpen,
	isGlobal,
	canImportGlobal,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`contacts.blacklist.${key}`);
	const [uploadAsGlobal, setUploadAsGlobal] = useState(isGlobal);
	const upload = useUploadBlacklistCsv({
		isGlobal: uploadAsGlobal,
		onImported: () => setIsOpen(false),
	});

	return (
		<Modal
			handleClose={() => setIsOpen(false)}
			handleSave={upload.submit}
			isLoading={upload.isLoading}
			isOpened={isOpen}
			submitButtonText={t("basics.upload")}
			title={ts("uploadTitle")}
		>
			<div className="flex flex-col gap-4">
				<BlacklistCsvUploadFields upload={upload} />

				{canImportGlobal && (
					<div className="flex items-center gap-2">
						<Checkbox
							isChecked={uploadAsGlobal}
							onChange={() => setUploadAsGlobal((prev) => !prev)}
						/>
						<span className="text-sm text-text-meta">{ts("uploadAsGlobal")}</span>
					</div>
				)}
			</div>
		</Modal>
	);
};
